import { IAntifraudManualReviewState, _antifraudManualReview } from './antifraudAnalysisTypes'

export type _reviewErrors = IAntifraudManualReviewState['errors']

const MESSAGES = {
  review: 'Selecione o parecer da área.',
  comment: 'A justificativa é obrigatória ao aprovar com restrição.',
  evidences: 'O anexo de evidência é obrigatório ao aprovar com restrição.'
}

export const RESTRICTION: _antifraudManualReview = 'approveWithRestriction'

export function requiresJustification (review: _antifraudManualReview): boolean {
  return review === RESTRICTION
}

export function validateManualReview (
  state: Pick<IAntifraudManualReviewState, 'review' | 'comment' | 'evidences'>
): _reviewErrors {
  if (!state.review) return { review: MESSAGES.review }

  if (!requiresJustification(state.review)) return {}

  const errors: _reviewErrors = {}

  if (!state.comment.trim()) errors.comment = MESSAGES.comment
  if (!state.evidences.length) errors.evidences = MESSAGES.evidences

  return errors
}

export function hasErrors (errors: _reviewErrors): boolean {
  return Object.keys(errors).length > 0
}
